import React, { FC } from 'react'
import { IUserModel } from './UserModel'
import DataTable, { TableColumn, TableAction } from '../../../../shared/components/DataTable'

interface UserTableProps {
  users: IUserModel[]
  currentPage: number
  totalPages: number
  loading: boolean
  onPageChange: (page: number) => void
  onEdit: (user: IUserModel) => void
  onDelete: (user: IUserModel) => void
  onResetPassword: (user: IUserModel) => void
}

const UserTable: FC<UserTableProps> = ({
  users,
  currentPage,
  totalPages,
  loading,
  onPageChange,
  onEdit,
  onDelete,
  onResetPassword,
}) => {
  const columns: TableColumn<IUserModel>[] = [
    {
      key: 'username',
      label: 'Kullanıcı',
      sortable: true,
      render: (_value, row) => (
        <div className='d-flex align-items-center gap-3'>
          <div className='symbol symbol-35px'>
            {row.image ? (
              <img src={row.image} alt={row.username} className='symbol-label' />
            ) : (
              <span className='symbol-label bg-light-primary text-primary fw-bold fs-6'>
                {row.username?.[0]?.toUpperCase()}
              </span>
            )}
          </div>
          <div>
            <span className='fw-bold text-dark d-block'>{row.username}</span>
          </div>
        </div>
      ),
    },
    {
      key: 'email',
      label: 'E-mail',
      render: (value) => (
        <a href={`mailto:${value}`} className='text-primary'>
          {value}
        </a>
      ),
    },
  ]

  const actions: TableAction<IUserModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil-square',
      className: 'btn-sm btn-light-warning',
      onClick: onEdit,
    },
    {
      label: 'Şifre Sıfırla',
      icon: 'bi bi-key',
      className: 'btn-sm btn-light-primary',
      onClick: onResetPassword,
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-sm btn-light-danger',
      onClick: onDelete,
    },
  ]

  return (
    <DataTable
      data={users}
      columns={columns}
      actions={actions}
      currentPage={currentPage}
      totalPages={totalPages}
      loading={loading}
      onPageChange={onPageChange}
      emptyMessage='Henüz kullanıcı oluşturulmamış'
    />
  )
}

export default UserTable
